'use client'
import Image from 'next/image'
import React from 'react'
import images from '~/asset/images'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from '~/components/ui/dialog'
import { Button } from '../ui/button'
import { ZoomIn, ZoomOut } from 'lucide-react'

type Props = React.HTMLProps<HTMLImageElement>
const ImageBlog = (props: Props) => {
    const src = props.src ? props.src : images.thumbnailDefault.src
    if (!props.alt) props.alt = 'image in blog website Ánh Văn Hóa'
    return (
        <Dialog>
            <DialogTrigger asChild>
                <Image
                    src={images.thumbnailDefault}
                    alt={props.alt}
                    width={2000}
                    height={2000}
                    loader={() => src}
                    className='mb-3 mt-0 w-full rounded-md'
                />
            </DialogTrigger>
            <em>
                <span className='block select-none pb-4 text-center text-base dark:text-slate-400'>{props.alt}</span>
            </em>
            <DialogContent className='max-w-(--breakpoint-md) p-0'>
                <DialogHeader>
                    <DialogTitle asChild>
                        <div className='w-full overflow-hidden rounded-md max-h-[calc(100vh-50px)]'>
                            <Image
                                src={images.thumbnailDefault}
                                alt={props.alt}
                                width={2000}
                                height={2000}
                                loader={() => src}
                                className='rounded-md w-full h-full  object-contain'
                            />
                        </div>
                    </DialogTitle>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    )
}

export default ImageBlog
